import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, FormHelperText, Button, Typography } from "@mui/material";
import { RootState } from "../../store/store"; // Update the path as needed
import { resetAuthDetails } from "../../store/features/auth/authSlice";
import environment from '../../environments/environment';
import CircularProgress from '@mui/material/CircularProgress';
import * as constants from "../../constants";

interface AccessDeniedMessageProps {
  logo: string;
  errorMessage: string;
}

const AccessDeniedMessage: React.FC<AccessDeniedMessageProps> = ({
  logo,
  errorMessage
}) => {
  const dispatch = useDispatch();
  const userDetails = useSelector((state: RootState) => state.auth);
  function onLogout(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault(); 
      window.location.href = `https://login.microsoftonline.com/${environment.tenant}/oauth2/logout?post_logout_redirect_uri=${environment.ApplicationURL}`;
      sessionStorage.setItem("firstTime", "valid");
      dispatch(resetAuthDetails()); 
  }

  return (
    <>
      {(userDetails.messageRes === "No records found" ||  !userDetails.roles) ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={logo} alt="CMS Logo" width="80%" height="50%" loading="lazy" />
          <FormHelperText>
            <Typography
              component="div"  
              sx={{ color: "red", whiteSpace: "pre-line" }}
            >
              {errorMessage}
            </Typography>
           {errorMessage != constants.AUTH_SERVICES_VALIDATION && <Button
              style={{ marginTop: "10px" }}
              variant="contained"
              color="primary"
              onClick={onLogout}
            >
              Log in With another User
            </Button>}
          </FormHelperText>
        </Box>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <CircularProgress />
        </Box>
      )}

    </>
  );
};

export default AccessDeniedMessage;
